/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GaugeDataRepresentation
 */
export interface GaugeDataRepresentation {
    /**
     * 
     * @type {Array<number>}
     * @memberof GaugeDataRepresentation
     */
    values: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GaugeDataRepresentation
     */
    timesFrom: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GaugeDataRepresentation
     */
    timesTo: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GaugeDataRepresentation
     */
    dataIntegrity?: Array<number>;
}

/**
 * Check if a given object implements the GaugeDataRepresentation interface.
 */
export function instanceOfGaugeDataRepresentation(value: object): value is GaugeDataRepresentation {
    if (!('values' in value) || value['values'] === undefined) return false;
    if (!('timesFrom' in value) || value['timesFrom'] === undefined) return false;
    if (!('timesTo' in value) || value['timesTo'] === undefined) return false;
    return true;
}

export function GaugeDataRepresentationFromJSON(json: any): GaugeDataRepresentation {
    return GaugeDataRepresentationFromJSONTyped(json, false);
}

export function GaugeDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GaugeDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'values': json['values'],
        'timesFrom': json['timesFrom'],
        'timesTo': json['timesTo'],
        'dataIntegrity': json['dataIntegrity'] == null ? undefined : json['dataIntegrity'],
    };
}

export function GaugeDataRepresentationToJSON(json: any): GaugeDataRepresentation {
    return GaugeDataRepresentationToJSONTyped(json, false);
}

export function GaugeDataRepresentationToJSONTyped(value?: GaugeDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'values': value['values'],
        'timesFrom': value['timesFrom'],
        'timesTo': value['timesTo'],
        'dataIntegrity': value['dataIntegrity'],
    };
}

